import setup from './moduleSetup';

export default {
    name: 'orders',
    before: [],
    after: [],
    setup,
};
